import { useEffect } from "react";

const ParticlesBackground = () => {
  useEffect(() => {
    const loadParticles = () => {
      const script = document.createElement("script");
      script.src = "/particles.min.js";
      script.async = true;
      script.onload = () => {
        window.particlesJS.load("particles-js", "/particles-config.json", function () {
          console.log("✅ particles.js config loaded");
        });
      };
      document.body.appendChild(script);
    };

    loadParticles();
  }, []);

  return <div id="particles-js" className="particles-container particles-js"></div>;
};

export default ParticlesBackground;